import React, { useState } from 'react';
import './navbar.css'
import {
    Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    Button,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    NavbarText
  } from 'reactstrap';
  import {
    NavLink
  } from "react-router-dom";

  const CustomNavBar = (props) => {
    const [isOpen, setIsOpen] = useState(false);
    const openInNewTab = (url) => {
      const newWindow = window.open(url, '_self', 'noopener,noreferrer')
      if (newWindow) newWindow.opener = null
    }
    
    
    const toggle = () => setIsOpen(!isOpen);
  return (
    
    <>
      <Navbar  className="px-3  py-0 shadow p-2 position-relative fixed-top position-sticky" style={{background: "#ededed"}}  light expand="md">
        <NavbarBrand className="pl-2 text-dark" href="/">Hope</NavbarBrand>
        <NavbarToggler onClick={toggle} />
        <Collapse isOpen={isOpen} navbar>
          <Nav className="mr-auto" navbar>
            <NavItem >
              <NavLink  className="text-dark nav-link"  to="/Home" activeClassName="selected">Home</NavLink>
            </NavItem>
            <NavItem>
              <NavLink className="text-dark nav-link" to="/Feature" >Features/About</NavLink>
            </NavItem>
            <NavItem>
              
              <span className="text-dark nav-link" style={{cursor:"pointer"}}/* target="_blank" */ onClick={() => openInNewTab('https://forms.gle/XHmPDuTFyBg9qYto9')}
  >FeedBack</span>
            </NavItem>
            <NavItem>
              <NavLink className="text-dark nav-link" to="/Contact">Contact Us</NavLink>
            </NavItem>
            
          </Nav>
          
        </Collapse>
      </Navbar>


    </>


  );
}

export default CustomNavBar;




